import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import RestoreBagComponent from '@nykaa/cart-shared/components/RestoreBag';
import { EDD_EXPERIEMENT_HEADER } from '@nykaa/cart-shared/store/constants';
import { ORIGIN_SOURCE, deviceTypes } from '@nykaa/cart-shared/constants';
import { CART_TEXT_MESSAGES } from '@nykaa/cart-shared/constants/message';
import { stringInterpolation } from '@nykaa/cart-shared/helpers/utils';
import { restoreBag } from '@nykaa/cart-shared/store/service';
import { setCartInfo, setToastMessage } from '@nykaa/cart-shared/store/action';
import { State } from 'store/types';
import { IRestoreBag } from 'layouts/ShoppingBag/types';

const RestoreBagBottomSheet = ({
  togleShowRestoreBag,
  freeSamplesCommunicationDTO,
  isConvenienceFeeEnabled,
}: IRestoreBag): JSX.Element => {
  const dispatch = useDispatch();
  const { pincode } = useSelector((state: State) => state.cartReducer.cartInfo);
  const { cartEddWidget } = useSelector(
    (state: State) => state.remoteConfig.switches
  );
  const { totalItemsRemoved, removedItemDTOList } =
    freeSamplesCommunicationDTO || {};

  const {
    DYNAMIC_NO_DONT_WANT_FREEBIES,
    DYNAMIC_SORRY_DUE_TO_REMOVAL_OF_SOME_PRODUCTS_YOUR_1_FREE_SAMPLES_HAVE_BEEN_REMOVED,
    RESTORE_BAG,
  } = CART_TEXT_MESSAGES;

  const NoFreebiesText = stringInterpolation(DYNAMIC_NO_DONT_WANT_FREEBIES, {
    count: totalItemsRemoved,
  });
  const restoreBagTitle = stringInterpolation(
    DYNAMIC_SORRY_DUE_TO_REMOVAL_OF_SOME_PRODUCTS_YOUR_1_FREE_SAMPLES_HAVE_BEEN_REMOVED,
    { count: totalItemsRemoved }
  );

  const product = removedItemDTOList?.[0];
  const args = {
    titleHTML: restoreBagTitle,
    subtitle: product?.name,
    onClose: () => {
      togleShowRestoreBag();
    },
    isVisible: true,
    restoreBtn: {
      text: RESTORE_BAG,
      onClick: async () => {
        const params = {
          deviceType: deviceTypes.DESKTOP,
          pincode,
          originSource: ORIGIN_SOURCE.CART,
          headers: { [EDD_EXPERIEMENT_HEADER]: cartEddWidget },
          domain: __PLATFORM__,
          catalog_tag_filter: __PLATFORM__,
        };
        try {
          const data = await restoreBag(params, isConvenienceFeeEnabled);
          if (data) {
            setCartInfo(data)(dispatch);
          }
        } catch (error) {
          const { message } = error as Error;
          setToastMessage(message)(dispatch);
        }
      },
    },
    noFreebiesBtn: {
      text: NoFreebiesText,
      onClick: () => {
        togleShowRestoreBag();
      },
    },
    deviceType: deviceTypes.DESKTOP,
  };

  return <RestoreBagComponent {...args} />;
};

export default RestoreBagBottomSheet;
